var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	78068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"192":1,"774":1,"908":1,"1076":1,"1321":1,"1481":1,"1668":1,"2466":1,"2904":1,"2927":1,"4168":1,"4170":1,"5203":1,"5268":1,"5358":1,"5830":1,"5937":1,"6044":1,"6269":1,"6596":1,"8491":1,"8703":1,"8881":1,"9156":1,"9307":1,"10202":1,"10238":1,"10568":1,"11078":1,"11082":1,"11376":1,"12000":1,"12069":1,"13603":1,"13970":1,"14748":1,"16593":1,"17324":1,"17908":1,"18410":1,"18442":1,"18451":1,"18552":1,"18966":1,"19527":1,"19617":1,"19975":1,"20356":1,"20475":1,"21067":1,"21109":1,"21282":1,"21746":1,"22430":1,"22609":1,"22918":1,"23889":1,"24192":1,"25227":1,"26072":1,"26248":1,"26325":1,"26351":1,"26455":1,"27193":1,"27645":1,"28217":1,"28231":1,"28320":1,"28832":1,"29055":1,"29212":1,"29959":1,"30299":1,"30304":1,"30528":1,"30605":1,"30734":1,"31314":1,"31624":1,"31733":1,"32158":1,"32995":1,"34128":1,"35589":1,"35606":1,"35980":1,"36113":1,"36384":1,"36610":1,"36702":1,"37042":1,"37668":1,"38197":1,"38384":1,"38584":1,"38708":1,"38913":1,"39424":1,"40165":1,"40557":1,"40898":1,"41072":1,"41175":1,"41377":1,"41664":1,"41771":1,"41811":1,"42231":1,"42556":1,"42760":1,"43490":1,"43529":1,"43757":1,"43986":1,"44166":1,"44198":1,"44225":1,"44709":1,"46114":1,"46491":1,"46849":1,"46930":1,"47309":1,"47345":1,"48637":1,"49111":1,"49150":1,"49245":1,"49406":1,"49693":1,"50469":1,"50504":1,"50678":1,"50927":1,"51327":1,"51761":1,"52205":1,"52292":1,"54426":1,"54610":1,"54685":1,"55038":1,"55945":1,"56107":1,"56615":1,"56652":1,"57079":1,"57131":1,"57414":1,"57429":1,"57707":1,"57899":1,"58119":1,"58593":1,"59011":1,"59644":1,"60048":1,"61324":1,"61723":1,"61834":1,"61955":1,"62123":1,"62548":1,"62769":1,"62971":1,"64475":1,"64609":1,"64679":1,"65011":1,"65602":1,"66000":1,"66405":1,"66960":1,"67736":1,"68704":1,"68781":1,"68930":1,"69314":1,"69361":1,"69401":1,"69799":1,"70331":1,"70413":1,"70917":1,"71163":1,"71274":1,"71480":1,"72093":1,"72985":1,"73419":1,"73618":1,"73762":1,"75012":1,"75020":1,"75225":1,"75353":1,"75364":1,"75540":1,"75723":1,"75871":1,"76605":1,"77133":1,"77292":1,"77520":1,"77567":1,"77863":1,"78674":1,"78785":1,"78855":1,"79095":1,"79329":1,"80259":1,"81020":1,"81159":1,"81995":1,"82295":1,"82757":1,"82983":1,"83455":1,"83605":1,"83833":1,"83952":1,"84091":1,"85924":1,"86071":1,"86603":1,"87072":1,"88397":1,"89424":1,"89925":1,"90017":1,"90020":1,"90595":1,"90919":1,"91115":1,"91248":1,"91481":1,"91539":1,"91571":1,"92224":1,"92767":1,"94064":1,"94932":1,"94990":1,"95410":1,"96048":1,"96053":1,"96279":1,"96977":1,"97857":1,"98005":1,"98087":1,"98259":1,"98527":1,"99724":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr